const userData1 = {
    emailId: "abc@pesico.com",
    details: [
        {
            sector: "AMESA",
            BU: "INDIA",
            category: {
                Directs: [
                    {
                        COMMODITIES: {
                            "EDIBLE OILS AND FATS": [
                                "BUTTER",
                                "CANOLA OIL",
                                "CORN OIL",
                                "COTTONSEED OIL",
                                "OIL BLENDS",
                                "OLIVE OIL",
                                "OTHER FATS",
                                "OTHER VEGETABLE OIL",
                                "PALM FAT",
                                "PALM OIL",
                                "RICE BRAN OIL",
                                "SAFFLOWER OIL",
                                "SESAME OIL",
                                "SOYABEAN OIL",
                                "SUNFLOWER OIL",
                            ],
                            OATS: ["FLOUR", "GROATS", "ROLLED", "WHOLE"],
                            RICE: ["RICE DERIVATIVES", "WHOLE"],
                            WHEAT: ["DERIVATIVES", "FLOUR", "WHOLE WHEAT"],
                        },
                    },
                ],
                Coman: "Coman",
            },
        },
        {
            sector: "APAC",
            BU: "XYZ",
            category: {
                Directs3: [
                    {
                        COMMODITIES3: {
                            "EDIBLE OILS AND FATS3": [
                                "BUTTER3",
                                "CANOLA OIL3",
                                "CORN OIL3",
                                "COTTONSEED OIL3",
                                "OIL BLENDS3",
                                "OLIVE OIL3",
                                "OTHER FATS3",
                                "OTHER VEGETABLE OIL3",
                                "PALM FAT3",
                                "PALM OIL3",
                                "RICE BRAN OIL3",
                                "SAFFLOWER OIL3",
                                "SESAME OIL3",
                                "SOYABEAN OIL3",
                                "SUNFLOWER OIL3",
                            ],
                            OATS3: ["FLOUR3", "GROATS3", "ROLLED3", "WHOLE3"],
                            RICE3: ["RICE DERIVATIVES3", "WHOLE3"],
                            WHEAT3: ["DERIVATIVES3", "FLOUR3", "WHOLE WHEAT3"],
                        },
                    },
                ],
                Coman3: "Coman3",
            },
        },
        {
            sector: "APAC",
            BU: "CHINA",
            category: {
                Directs1: [
                    {
                        COMMODITIES1: {
                            "EDIBLE OILS AND FATS": [
                                "BUTTER1",
                                "CANOLA OIL1",
                                "CORN OIL1",
                                "COTTONSEED OIL1",
                                "OIL BLENDS1",
                                "OLIVE OIL1",
                                "OTHER FATS1",
                                "OTHER VEGETABLE OIL1",
                                "PALM FAT1",
                                "PALM OIL1",
                                "RICE BRAN OIL1",
                                "SAFFLOWER OIL1",
                                "SESAME OIL1",
                                "SOYABEAN OIL1",
                                "SUNFLOWER OIL1",
                            ],
                            OATS1: ["FLOUR1", "GROATS1", "ROLLED1", "WHOLE1"],
                            RICE1: ["RICE DERIVATIVES1", "WHOLE1"],
                            WHEAT1: ["DERIVATIVES1", "FLOUR1", "WHOLE WHEAT1"],
                        },
                    },
                ],
                Coman1: "Coman1",
            },
        },
        {
            sector: "PBNA",
            BU: "ABC",
            category: {
                Directs2: [
                    {
                        COMMODITIES2: {
                            "EDIBLE OILS AND FATS2": [
                                "BUTTER2",
                                "CANOLA OIL2",
                                "CORN OIL2",
                                "COTTONSEED OIL2",
                                "OIL BLENDS2",
                                "OLIVE OIL2",
                            ],
                            OATS2: ["FLOUR2", "GROATS2", "ROLLED2", "WHOLE2"],
                            RICE2: ["RICE DERIVATIVES2", "WHOLE2"],
                            WHEAT2: ["DERIVATIVES2", "FLOUR2", "WHOLE WHEAT2"],
                        },
                    },
                ],
                Coman2: "Coman2",
            },
        },
        {
            sector: "AMESA",
            BU: "SRILANKA",
            category: [
                {
                    Directs: [
                        {
                            "FRUITS & VEGETABLES": {
                                CORN: [
                                    "DERIVATIVES",
                                    "FLOUR",
                                    "MEAL",
                                    "POPCORN",
                                    "WHITE",
                                    "YELLOW",
                                ],
                                DERIVATIVES: ["FRUIT", "VEGETABLE"],
                                JUICE: ["APPLE", "CHERRY", "CITRUS", "CRANBERRY", "LEMON"],
                            },
                        },
                    ],
                },
            ],
        },
    ],
};

const userData2 = {
    emailId: "abc@pesico.com",
    year: 2023,
    details: [
        {
            sector: "AMESA",
            BU: "INDIA",
            category: {
                L0: [
                    {
                        name: "Directs",
                        L1: [
                            {
                                name: "COMMODITIES",
                                L2: [
                                    {
                                        name: "EDIBLE OILS AND FATS",
                                        L3: [
                                            "BUTTER",
                                            "CANOLA OIL",
                                            "CORN OIL",
                                            "COTTONSEED OIL",
                                            "OIL BLENDS",
                                            "OLIVE OIL",
                                            "OTHER FATS",
                                            "OTHER VEGETABLE OIL",
                                            "PALM FAT",
                                            "PALM OIL",
                                            "RICE BRAN OIL",
                                            "SAFFLOWER OIL",
                                            "SESAME OIL",
                                            "SOYABEAN OIL",
                                            "SUNFLOWER OIL",
                                        ],
                                    },
                                    {
                                        name: "OATS",
                                        L3: ["FLOUR2", "GROATS2", "ROLLED2", "WHOLE2"],
                                    },
                                    {
                                        name: "RICE",
                                        L3: ["RICE DERIVATIVES2", "WHOLE2"],
                                    },
                                    {
                                        name: "WHEAT",
                                        L3: ["DERIVATIVES2", "FLOUR2", "WHOLE WHEAT2"],
                                    },
                                ],
                            },
                        ],
                    },
                    { name: "Coman" },
                ],
            },
        },
        {
            sector: "APAC",
            BU: "CHINA",
            category: {
                L0: [
                    {
                        name: "Directs-1",
                        L1: [
                            {
                                name: "COMMODITIES-1",
                                L2: [
                                    {
                                        name: "EDIBLE OILS AND FATS-1",
                                        L3: [
                                            "BUTTER-1",
                                            "CANOLA OIL-1",
                                            "CORN OIL-1",
                                            "COTTONSEED OIL-1",
                                            "OIL BLENDS-1",
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    ],
};

const userData = {
    "year": [
        2024,
        2023
    ],
    "emailId": "sonya.xu@pepsico.com",
    "name": "Sonya Xu",
    "gpId": "80892128",
    "defaultRole": "Category COE",
    "details": [
        {
            "role": "Category COE",
            "roleDetail": [
                {
                    "sector": "APAC",
                    "bu": "China",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "New Zealand",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "Australia",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "Indochina",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "Korea",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "Singapore",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "Philippines",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "sector": "APAC",
                    "bu": "Vietnam",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        {
            "role": "Category Manager",
            "roleDetail": [
                {
                    "sector": "APAC",
                    "bu": "GCR/China",
                    "category": {
                        "l0": [
                            {
                                "name": "GP Indirects",
                                "l1": [
                                    {
                                        "name": "A&M NON-WORKING",
                                        "l2": [
                                            "Advertisng Prductn",
                                            "Agency Fees",
                                            "All Other",
                                            "Consumer Promos",
                                            "Innovtns&Insights",
                                            "Package Design",
                                            "Point of Sale S&D",
                                            "Trading Goods",
                                            "Sponsorships S&D"
                                        ]
                                    },
                                    {
                                        "name": "FACILITIES",
                                        "l2": [
                                            "Buildings",
                                            "Catering",
                                            "Management",
                                            "Utilities"
                                        ]
                                    },
                                    {
                                        "name": "BUSINESS SERVICES",
                                        "l2": [
                                            "Building Services",
                                            "Cnclt&Legal Svcs",
                                            "Capitalized Fleet",
                                            "Company Cars/Leasing",
                                            "Fuel Oil&Gas",
                                            "HR Services",
                                            "Professional Svcs",
                                            "Sanitn&Hygiene",
                                            "Temp Labor-NonOps",
                                            "Temp Labor-Ops",
                                            "Travel & Ent",
                                            "Professional Srvs Experimntl"
                                        ]
                                    },
                                    {
                                        "name": "IT",
                                        "l2": [
                                            "Hardware",
                                            "Software",
                                            "Professional Srvs",
                                            "Telecommunication"
                                        ]
                                    },
                                    {
                                        "name": "MAINT, REPAIRS, OPS",
                                        "l2": [
                                            "Belts & Conveyors",
                                            "Chillers & Coolers",
                                            "Cleaning & Sanitation",
                                            "Coders",
                                            "Lab",
                                            "OEM",
                                            "Operating Supplies",
                                            "Power Transmission",
                                            "Repair and Maint",
                                            "Uniforms",
                                            "Marketing Equipment SpPrts&Srv"
                                        ]
                                    },
                                    {
                                        "name": "A&M WORKING",
                                        "l2": [
                                            "Consumer Promos",
                                            "Digital Media",
                                            "Direct Mail",
                                            "Free Stndng Insert",
                                            "InStore & POS",
                                            "Media Placements",
                                            "Premiums",
                                            "Promotional Packs",
                                            "Public Relations",
                                            "Sampling",
                                            "Sponsorships",
                                            "Talent"
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    ]
}

const allCategoryL0 = [
    { displayText: 'OTHERS', id: 1 },
    { displayText: 'GP DIRECTS', id: 2 },
    { displayText: 'GP INDIRECTS', id: 3 },
    { displayText: 'CO MAN', id: 4 },
]

const allCategoryL0NPS = [
    { displayText: 'OTHERS', id: 1 },
    { displayText: 'GP DIRECTS', id: 2 },
    { displayText: 'GP INDIRECTS', id: 3 },
    { displayText: 'CO MAN', id: 4 },
    { displayText: 'MULTI CATEGORY', id: 5 },
]

export { userData, userData2, userData1, allCategoryL0, allCategoryL0NPS };
